var tokens = {};
var i = 0;
var getToken = function () { return "delay_token_" + i++; };
export var CmdToken = {
    source: function () {
        var token = getToken();
        var cancel = function () {
            var _a;
            clearTimeout((_a = tokens[token]) === null || _a === void 0 ? void 0 : _a.timer);
            delete tokens[token];
        };
        var execute = function () {
            var t = tokens[token];
            if (t) {
                clearTimeout(t.timer);
                return t.fn();
            }
        };
        return { token: token, cancel: cancel, execute: execute };
    }
};
export var delayExec = function (fn, timeout, cmdToken) {
    return new Promise(function (resolve, reject) {
        var timer = setTimeout(function () {
            fn().then(resolve).catch(reject);
        }, timeout);
        if (cmdToken) {
            tokens[cmdToken] = { timer: timer, fn: fn };
        }
    });
};
//# sourceMappingURL=delay-exec.js.map